<template>
  <div>
    <div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pojazdy/środki transportu</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Lista pojazdów</h6>
              <button class="btn btn-sm btn-success" @click="addPojazd"><i class="bi bi-plus-lg me-1"></i> Dodaj
                pojazd</button>
            </div>
            <div class="custom-table">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nazwa</th>
                    <th>Numer rejestracyjny</th>
                    <th>Użyty</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
				  <tr v-if="addingNew">
                    <td>Nowy</td>
                    <td><input v-model="newPojazd.name" class="form-control" /></td>
                    <td><input v-model="newPojazd.nr_rejestracyjny" class="form-control" /></td>
                    <td>
                      <button @click="saveNewPojazd" class="btn btn-sm btn-success me-1"><i
                          class="bi bi-save me-2"></i>Zapisz
                      </button>
                      <button @click="cancelNewPojazd" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2"></i>Anuluj
                      </button>
                    </td>
                  </tr>
                  <tr v-for="(pojazd, index) in pojazdy" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === pojazd.id" v-model="pojazd.name" class="form-control" />
                      <span v-else>{{ pojazd.name }}</span>
                    </td>
                    <td>
                      <input v-if="editingId === pojazd.id" v-model="pojazd.nr_rejestracyjny" class="form-control" />
                      <span v-else>{{ pojazd.nr_rejestracyjny }}</span>
                    </td>
                    <td>{{ pojazd.delegacje_count }}</td>
                    <td>
                      <button v-if="editingId === pojazd.id" @click="updatePojazd(pojazd)" class="btn btn-sm btn-success me-2">
                        Zapisz
                      </button>
                      <button v-else @click="editPojazd(pojazd.id)" class="btn btn-sm btn-outline-info me-2"><i
                          class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button v-if="pojazd.delegacje_count === 0" @click="deletePojazd(pojazd.id)" class="btn btn-sm btn-danger">
                        <i class="bi bi-trash me-2"></i>Usuń
                      </button>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Modal } from 'bootstrap';

export default {
  props: {
    pojazdy: { type: Array, default: () => [] },
  },

  data() {
    return {
      modalObj: null,
      editingId: null,
      addingNew: false,
      newPojazd: this.getEmptyForm()
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {
    resetForm() {
      this.editingId = null;
      this.addingNew = false;
      this.newPojazd = this.getEmptyForm();
    },
    getEmptyForm() {
      return {
        id: null,
        name: '',
       nr_rejestracyjny: ''
      };
    },

    addPojazd() {
      this.addingNew = true;
      this.newPojazd = this.getEmptyForm();
    },

    cancelNewPojazd() {
      this.addingNew = false;
      this.newPojazd = this.getEmptyForm();
    },

    editPojazd(id) {
      this.editingId = id;
    },

    updatePojazd(pojazd) {
      this.$emit("update-pojazd", { ...pojazd });
      this.resetForm();
      this.hide();
    },

    saveNewPojazd() {
      if (!this.newPojazd) {
        this.errorMsg("Pojazd musi posiadać nazwę.");
        return;
      }

      this.$emit("save-pojazd", this.newPojazd);
      this.resetForm();
      this.hide();
    },

    deletePojazd(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pojazdu',
        html: 'Czy na pewno chcesz usunąć wybrany pojazd?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {

          this.$emit("delete-pojazd", id);
          this.resetForm();
          this.hide();

        }

      });
    },

    show() {
      this.modalObj.show();
    },
    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },


    hide() {
      this.resetForm();

      if (this.modalObj) {
        this.modalObj.hide();
      }
    }
  }
};
</script>

<style>
.position-absolute {
  background: white;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
}
</style>